import { render, staticRenderFns } from "./mallCategory.vue?vue&type=template&id=37b2f2ab&scoped=true"
import script from "./mallCategory.vue?vue&type=script&lang=js"
export * from "./mallCategory.vue?vue&type=script&lang=js"
import style0 from "./mallCategory.vue?vue&type=style&index=0&id=37b2f2ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b2f2ab",
  null
  
)

export default component.exports